<template>
  <svg
    :height="width"
    :width="height"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="fill"
      d="M11 14.59V3a1 1 0 0 1 2 0v11.59l3.3-3.3a1 1 0 0 1 1.4 1.42l-5 5a1 1 0 0 1-1.4 0l-5-5a1 1 0 0 1 1.4-1.42l3.3 3.3zM3 17a1 1 0 0 1 2 0v3h14v-3a1 1 0 0 1 2 0v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconUpload',

  props: {
    fill: {
      type: String,
      default: '#00d26e'
    },

    width: {
      type: String,
      default: '20px'
    },

    height: {
      type: String,
      default: '14px'
    }
  }
}
</script>
